// extracted by mini-css-extract-plugin
export default {"statusDisabled":"DataListStatusCell_statusDisabled__mcbQ5"};